import React from 'react';

import { AppOnlyPill } from '../../../components/Clickables/Pill/AppOnlyPill';
import { Heading } from '../../../components/Heading/Heading';
import { Text } from '../../../components/Text/Text';
import { useIsMobileScreenWidthOrThinner } from '../../../helpers/hooks/useScreenWidth';
import { CircleImageAndText } from './CircleImageAndText';
import { InternalLink } from '../../../components/Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../../components/Icons/ArrowRightIcon';
import { StaticImageData } from 'next/image';

interface IProps {
  headingText: string;
  bodyText: string;
  readMoreLink?: string;
  bgImage?: StaticImageData;
  imgSrc: StaticImageData;
  imgAlt: string;
  imgRight?: boolean;
  featuresList: {
    id: number;
    headingText: string;
    bodyText: string[];
  }[];
}

export const FeatureDetailsSection = ({
  headingText,
  bodyText,
  readMoreLink,
  bgImage,
  imgSrc,
  imgAlt,
  imgRight = true,
  featuresList,
}: IProps) => {
  const isMobileScreenWidthOrThinner = useIsMobileScreenWidthOrThinner();
  return (
    <CircleImageAndText imgSrc={imgSrc} imgAlt={imgAlt} imgRight={imgRight}>
      <div
        className="-mx-6 bg-cover bg-no-repeat sm:-mx-0"
        style={
          bgImage && isMobileScreenWidthOrThinner
            ? { backgroundImage: `url(${bgImage.src})` }
            : undefined
        }
      >
        <div className="px-6">
          <AppOnlyPill />
          <Heading variant="md">{headingText}</Heading>
          <Text className="mt-6 sm:mx-auto sm:my-4 md:mt-5" variant="lg">
            {bodyText}
          </Text>
          {featuresList.map(feature => (
            <div key={`feature-detail-list${feature.id}`} className="sm:pb-4">
              <div className="flex flex-row items-center gap-2">
                <div className="bg-tuna-tint flex items-center rounded-full p-1.5">
                  <ArrowRightIcon width={20} height={20} />
                </div>
                <Heading variant="sm">{feature.headingText}</Heading>
              </div>

              {feature.bodyText.map((textBlock, i) => (
                <Text
                  className="text-trench mt-2 mb-4 sm:mx-auto md:mt-5"
                  key={`feature-detail-${i}`}
                >
                  {textBlock}
                </Text>
              ))}
            </div>
          ))}
          {readMoreLink && (
            <InternalLink
              to={readMoreLink}
              className="font-heading text-pinktail hover:text-pinktail-shade flex items-center py-6 pr-6"
            >
              Read more
              <div className="ml-0.5 inline-block">
                <ArrowRightIcon width={20} height={20} />
              </div>
            </InternalLink>
          )}
        </div>
      </div>
    </CircleImageAndText>
  );
};
